import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Main = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        axios.get(`http://localhost:8000/api/displayAll`)
            .then(res => {
                console.log(res);
                setData(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className='app-container'>
                <div className="navbar navbar-light">
                    <h1>Pet Shelter</h1>
                    <Link to={'/pets/new'}>add a pet to the shelter</Link>
                </div>
                <div className="loading">
                    <div className="spinner"></div>
                    <p className="loading-text">Loading adorable pets...</p>
                </div>
            </div>
        );
    }

    return (
        <div className='app-container fade-in'>
            <div className="navbar navbar-light">
                <h1>Pet Shelter</h1>
                <Link to={'/pets/new'}>add a pet to the shelter</Link>
            </div>
            
            <h3>These pets are looking for a good home</h3>
            
            {data.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">🐾</div>
                    <h4>No pets yet!</h4>
                    <p>Be the first to add a furry friend looking for a home</p>
                    <Link to={'/pets/new'}>
                        <button className="btn btn-primary">Add First Pet</button>
                    </Link>
                </div>
            ) : (
                <div className="table-container scale-in">
                    <table className='table table-sm'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((e, index) => (
                                <tr key={index}>
                                    <td>{e.name}</td>
                                    <td>{e.type}</td>
                                    <td className='action-links'>
                                        <Link to={`/pets/${e._id}`}>details</Link>
                                        <Link to={`pets/${e._id}/edit`}>edit</Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Main;